import React from 'react'
import classNames from 'classnames'
import { IncreaseLoanAmountBannerBase } from '@/components/banners/IncreaseLoanAmountBannerBase'
import { messages } from './messages'
import type { IIncreaseLoanAmountBannerLightProps } from './types'
import './styles.scss'

export const IncreaseLoanAmountBannerLight: React.FC<IIncreaseLoanAmountBannerLightProps> = ({
  buttonModifiers,
  className,
  titleClassName,
  comment,
}) => {
  return (
    <IncreaseLoanAmountBannerBase
      className={classNames('increaseLoanAmountBannerLight', className)}
      title={messages.title}
      buttonText={messages.action}
      buttonModifiers={buttonModifiers}
      titleClassName={titleClassName}
      actionClassName="increaseLoanAmountBannerLight__action"
      subtitleClassName="increaseLoanAmountBannerLight__subtitle"
      comment={comment}
    />
  )
}
